import { CheckoutLocale, StripeElementLocale } from "@stripe/stripe-js";

const validCheckoutLocales: CheckoutLocale[] = [
  'auto', 'bg', 'cs', 'da', 'de', 'el', 'en', 'en-GB', 'es', 'es-419', 'et', 'fi', 'fil', 'fr', 'fr-CA', 'hr', 'hu', 'id', 'it', 'ja', 'lt', 'lv', 'ms', 'mt', 'nb', 'nl', 'pl', 'pt', 'pt-BR', 'ro', 'ru', 'sk', 'sl', 'sv', 'th', 'tr', 'zh', 'zh-HK', 'zh-TW'
];
const validStripeElementLocales: StripeElementLocale[] = [
  'auto', 'ar', 'bg', 'cs', 'da', 'de', 'el', 'en', 'en-AU', 'en-CA', 'en-NZ', 'en-GB', 'es', 'es-ES', 'es-419', 'et', 'fi', 'fil', 'fr', 'fr-CA', 'fr-FR', 'he', 'hu', 'hr', 'id', 'it', 'it-IT', 'ja', 'ko', 'lt', 'lv', 'ms', 'mt', 'nb', 'nl', 'no', 'pl', 'pt', 'pt-BR', 'ro', 'ru', 'sk', 'sl', 'sv', 'th', 'tr', 'vi', 'zh', 'zh-HK', 'zh-TW'
];

export const isValidStripeLanguage = (language: string): language is CheckoutLocale => {
  return validCheckoutLocales.includes(language as CheckoutLocale) || validStripeElementLocales.includes(language as StripeElementLocale);
};
